import { css } from "styled-components";

export enum FontSize {
  H1 = "62px",
  H2 = "44px",
  H3 = "30px",
  H4 = "18px",
  Large = "16px",
  Standard = "14px",
  Small = "12px",
  Tiny = "10px",
}

export enum FontSizeV2 {
  H1 = "64px",
  H2 = "40px",
  H3 = "32px",
  H4 = "32px",
  H5 = "20px",
  Standard = "16px",
  Small = "14px",
}

export enum FontFamily {
  LeagueSpartanBold = "League Spartan",
  MontserratSemiBold = "Montserrat-SemiBold",
  MontserratBold = "Montserrat-Bold",
  MontserratRegular = "Montserrat-Regular",
  SpaceGroteskRegular = "SpaceGrotesk-Regular",
  SpaceGroteskMedium = "SpaceGrotesk-Medium",
  SpaceGroteskBold = "SpaceGrotesk-Bold",
}

export const TypographyV2 = {
  h1: css`
    font-family: ${FontFamily.SpaceGroteskBold}, Helvetica;
    font-size: ${FontSizeV2.H1};
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0;
  `,
  h2: css`
    font-family: ${FontFamily.SpaceGroteskBold}, Helvetica;
    font-size: ${FontSizeV2.H2};
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0;
  `,
  h3: css`
    font-family: ${FontFamily.SpaceGroteskMedium}, Helvetica;
    font-size: ${FontSizeV2.H3};
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0;
  `,
  h4: css`
    font-family: ${FontFamily.SpaceGroteskRegular}, Helvetica;
    font-size: ${FontSizeV2.H4};
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0;
  `,
  h5: css`
    font-family: ${FontFamily.SpaceGroteskBold}, Helvetica;
    font-size: ${FontSizeV2.H5};
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0;
  `,
  b1: css`
    font-family: ${FontFamily.SpaceGroteskBold}, Helvetica;
    font-size: ${FontSizeV2.Standard};
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0;
  `,
  b2: css`
    font-family: ${FontFamily.SpaceGroteskMedium}, Helvetica;
    font-size: ${FontSizeV2.Standard};
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0;
  `,
  s1: css`
    font-family: ${FontFamily.SpaceGroteskMedium}, Helvetica;
    font-size: ${FontSizeV2.Small};
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0;
  `,
  b3: css`
    font-family: ${FontFamily.SpaceGroteskMedium}, Helvetica;
    font-size: 22px;
    font-weight: 500;
    line-height: 33px;
    letter-spacing: 0;
  `,
} as const;
